import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'
import { useSelectedFinanceCompanyUUID } from './useSelectedFinanceCompanyUUID'
import { useSelector } from 'react-redux'
import type { FirestoreReducer } from 'react-redux-firebase'
import type { Company } from 'types/company'
type FirestoreState = FirestoreReducer.Reducer

export const useSelectedFinanceCompany = () => {
	const selectedFinanceCompanyUUID = useSelectedFinanceCompanyUUID()
	const storeAs = `selectedFinanceCompany_${selectedFinanceCompanyUUID}`
	useFirestoreConnect(() => {
		if (selectedFinanceCompanyUUID) {
			return [
				{
					collection: 'company',
					doc: selectedFinanceCompanyUUID,
					storeAs,
				},
			]
		}
		return []
	})

	return useSelector(
		({ firestoreReducer }: { firestoreReducer: FirestoreState }) => {
			if (!firestoreReducer.ordered) {
				return { loading: true, company: null }
			}

			const company = firestoreReducer.ordered[storeAs]

			if (!isLoaded(company)) {
				return { loading: true, company: null }
			}

			return { loading: false, company: company[0] as Company }
		},
	)
}
